module.exports = __webpack_public_path__ + "3d01bf6d820b5904252a21c8a14721b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/manufacturer.png
// module id = 3242
// module chunks = 0